import styled from "styled-components";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
export const ScrollHorizontalList = styled.ul.withConfig({
    displayName: "styled__ScrollHorizontalList",
    componentId: "sc-e01baa7d-0"
})`
	${FlexMixin()}
	gap: ${({ $gap ='8px'  })=>$gap};
	overflow-x: auto;
	padding-bottom: 8px;
	margin: 0;
`;
export const ScrollHorizontalItem = styled.li.withConfig({
    displayName: "styled__ScrollHorizontalItem",
    componentId: "sc-e01baa7d-1"
})``;

//# sourceMappingURL=styled.js.map